const SkillsInfo = [
  "C++",
  "Java",
  "HTML",
  "CSS",
  "Javascript",
  "React",
  "Node.js",
  "MYSQL",
  "MongoDB",
  "Git and Github",
  "Data Structures",
  "Algorithms",
  "DBMS",
  "OOPS",
];

export default SkillsInfo;
